"use client";

import type { FC } from "react";
import useRewardsNotification from "./hooks/useRewardsNotification";

type Props = {
  notification?: RewardsNotification;
  gameId?: string;
};

// Renders nothing — the prompt is drawn by the shared NotificationWorker; this only decides when to raise it.
const RewardsNotification: FC<Props> = ({ notification, gameId }) => {
  useRewardsNotification({ notification, gameId });

  return null;
};

export default RewardsNotification;
